import { render, staticRenderFns } from "./KTextTruncator.vue?vue&type=template&id=0e5d3066"
import script from "./KTextTruncator.vue?vue&type=script&lang=js"
export * from "./KTextTruncator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports